import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    margin-bottom: 4px;
    align-items: center;

    > span {
        margin-left: 4px;
    }
`;